import React, { useState } from 'react';
import { observer } from 'mobx-react';
import { Modal, Form, InputNumber, message, Row, Col, Select,Input } from 'antd';
import { http } from 'libs';
import store from './store';

export default observer(function () {
    const { TextArea } = Input;
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [cancelNo, setCancelno] = useState(store.handleRecord.cancelNumber)

    function handleSubmit() {
        const formData = form.getFieldsValue();
        if (cancelNo < 0) return message.error('请输入正确的数量！')
        // if (!formData['close_reason']) {
        //     return message.error('请选择取消原因！');
        // };
        // if (formData['close_reason']==='其他') {
        //     if (!formData['close_remarks']) {
        //         return message.error('请输入取消备注');
        //     }else if(formData['close_remarks'].length>50){
        //         return message.error('取消备注不能超过50字！');
        //     }
        // }
        setLoading(true);
        http.post(
            '/javaApi/front/quote/quoteItemCancel',
            { itemId: store.handleRecord.id, cancelNumber: cancelNo }
        ).then(() => {
            store.numberVisible = false;
            message.success('操作成功');
            store.fetchQuoteRecords()
        }).finally(() => setLoading(false))
    }


    return (
        <Modal
            visible
            maskClosable={false}
            title="修改已取消数"
            centered
            onCancel={() => store.numberVisible = false}
            confirmLoading={loading}
            onOk={handleSubmit}>
            <Form form={form}>
                <Form.Item style={{ marginLeft: 10 }}>
                    <Row>
                        <Col span={12}>
                            <div>已下推：{store.handleRecord.deliverNumber}</div>
                        </Col>
                        <Col span={12}>
                            <div>原总数：{store.handleRecord.number}</div>
                        </Col>
                    </Row>
                </Form.Item>
                <Row>
                <Col span={12}>
                    <Form.Item label='已取消' style={{ marginLeft: 10 }}>
                        <InputNumber min={0} precision={0} value={cancelNo} onChange={e => setCancelno(e)} />
                    </Form.Item>
                </Col>
                {/* <Col span={12}>
                    <Form.Item name='close_reason' required label='取消原因' style={{ marginRight: 30 }}>
                        <Select placeholder="请选择" >
                            <Select.Option value="换发票抬头">换发票抬头</Select.Option>
                            <Select.Option value="换供应商">换供应商</Select.Option>
                            <Select.Option value="换物料">换物料</Select.Option>
                            <Select.Option value="真实取消">真实取消</Select.Option>
                            <Select.Option value="其他">其他</Select.Option>
                        </Select>
                    </Form.Item>
                </Col> */}
                </Row>
                {/* <Form.Item name='close_remarks' label='取消备注' style={{ marginRight: 30 }}>
                    <TextArea  
                        showCount
                        maxLength={50}
                        rows={2} 
                        placeholder="请输入取消备注，不超过50字" />
                </Form.Item> */}
                <Form.Item>
                    <div style={{ fontSize: 12, color: 'red', marginTop: 10 }}>注：已取消不得大于原总数与实际出库的差值，已取消修改至最大时无法再次修改</div>
                </Form.Item>
            </Form>
        </Modal>)
})